import {
    AccordionButton,
    AccordionButtonIconWrapper,
} from 'components/Accordion';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { css } from 'styled-components';

const AccordionButtonDropdown = css`
    margin-left: auto;
    color: ${({ theme }) => theme.purple_1};
    font-size: 1.31em;
`;

function FilterAccordionButton({ isActive, isOpen, Icon, children, ...props }) {
    return (
        <AccordionButton isActive={isActive} aria-expanded={isOpen} {...props}>
            {Icon ? (
                <AccordionButtonIconWrapper
                    aria-hidden="true"
                    isActive={isActive}
                >
                    <Icon />
                </AccordionButtonIconWrapper>
            ) : null}
            {children}
            {isOpen ? (
                <IoMdArrowDropup
                    aria-hidden="true"
                    css={AccordionButtonDropdown}
                />
            ) : (
                <IoMdArrowDropdown
                    aria-hidden="true"
                    css={AccordionButtonDropdown}
                />
            )}
        </AccordionButton>
    );
}

export default FilterAccordionButton;
